// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Signin/Pool.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-intake-public-page {
  min-height: 100vh;
  background: #f7fbfd;
  color: #102138;
}

.parent-lookup-page {
  background-image:
    linear-gradient(
      115deg,
      rgba(247, 251, 253, 0.86),
      rgba(247, 251, 253, 0.78) 48%,
      rgba(247, 251, 253, 0.88)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.parent-lookup-page .customer-intake-public-header {
  background: rgba(255, 255, 255, 0.76);
  backdrop-filter: blur(12px);
}

.customer-intake-public-header {
  background: #ffffff;
  border-bottom: 1px solid rgba(16, 33, 56, 0.1);
}

.customer-intake-public-header-inner {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.customer-intake-public-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  background: #4da7db;
}

.customer-intake-public-header-actions .MuiIconButton-root {
  padding: 6px;
}

.customer-intake-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.customer-intake-brand-mark {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #ffffff;
  background: #4da7db;
}

.customer-intake-brand-mark img {
  display: block;
  width: 28px;
  height: 28px;
  object-fit: contain;
  border-radius: 5px;
}

.customer-intake-brand-name {
  color: #102138;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
}

.customer-intake-brand-tagline {
  color: #6b7c8f;
  font-size: 0.72rem;
  font-style: italic;
  line-height: 1.3;
}

.customer-intake-page-container {
  padding-top: 40px;
  padding-bottom: 48px;
}

.customer-intake-hero {
  text-align: center;
  margin-bottom: 28px;
}

.customer-intake-eyebrow {
  color: #4da7db;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.customer-intake-title {
  color: #102138;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.customer-intake-subtitle {
  display: block;
  width: 100%;
  margin: 10px auto 0;
  text-align: center;
  color: #607285;
}

.customer-intake-card {
  border: 1px solid rgba(16, 33, 56, 0.1);
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 26px rgba(16, 33, 56, 0.07);
}

.customer-intake-qr-card {
  padding: 28px;
}

.customer-intake-qr-frame {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  border: 1px solid rgba(77, 167, 219, 0.25);
  border-radius: 10px;
  background: #ffffff;
}

.customer-intake-qr-frame canvas {
  display: block;
  width: min(100%, 320px);
  height: auto;
}

.customer-intake-qr-link {
  overflow-wrap: anywhere;
  color: #4d6e8a;
}

.customer-intake-qr-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.customer-intake-info-card {
  height: 100%;
  padding: 28px;
}

.customer-intake-info-list {
  display: grid;
  gap: 18px;
  margin: 24px 0 0;
  padding: 0;
  list-style: none;
}

.customer-intake-info-list li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.customer-intake-info-list svg {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #4da7db;
}

.customer-intake-form-container {
  max-width: 760px;
}

.customer-intake-form-card {
  padding: 30px;
}

.parent-lookup-form-card {
  max-width: 760px;
  margin: 0 auto;
  padding: 30px;
}

.parent-lookup-search-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.95fr);
  gap: 24px;
  max-width: 1080px;
  margin: 0 auto;
  align-items: stretch;
}

.parent-lookup-poster-card {
  max-width: none;
  margin: 0;
  padding: 24px;
}

.parent-lookup-poster-frame {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
  background: transparent;
}

.parent-lookup-poster {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.parent-lookup-search-layout .parent-lookup-form-card {
  max-width: none;
  margin: 0;
}

.parent-lookup-form-column {
  min-width: 0;
}

.parent-lookup-search-layout--without-poster {
  display: block;
  width: 100%;
  max-width: 1080px;
}

.parent-lookup-search-layout--without-poster .parent-lookup-form-card {
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.parent-lookup-search-layout:not(
    .parent-lookup-search-layout--without-poster
  )
  .parent-lookup-poster-card,
.parent-lookup-search-layout:not(
    .parent-lookup-search-layout--without-poster
  )
  .parent-lookup-form-card {
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding: 0;
}

.parent-lookup-results {
  width: 100%;
  max-width: 1080px;
  margin-top: 24px;
  margin-right: auto;
  margin-left: auto;
}

.parent-lookup-form-column .parent-lookup-results {
  max-width: none;
  margin: 24px 0 0;
}

.parent-lookup-no-match {
  width: 100%;
  margin-top: 16px;
}

.parent-lookup-captcha-widget {
  min-height: 65px;
  display: flex;
  align-items: center;
}

.parent-lookup-student-card {
  padding: 28px;
  background: rgba(255, 255, 255, 0.62);
  backdrop-filter: blur(6px);
}

.parent-lookup-service-tabs {
  border-bottom: 1px solid rgba(16, 33, 56, 0.12);
}

.parent-lookup-package-card {
  padding: 20px;
  background: rgba(251, 253, 255, 0.56);
  backdrop-filter: blur(5px);
}

.parent-lookup-package-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.parent-lookup-class-card {
  padding: 14px;
  background: rgba(255, 255, 255, 0.48);
  backdrop-filter: blur(5px);
}

.customer-intake-policy-card {
  padding: 32px;
}

.customer-intake-policy-section {
  scroll-margin-top: 24px;
}

.customer-intake-policy-list .MuiListItemIcon {
  min-width: 36px;
}

.customer-intake-form-section {
  padding: 24px 0;
  border-top: 1px solid rgba(16, 33, 56, 0.1);
}

.customer-intake-form-section:first-of-type {
  padding-top: 0;
  border-top: 0;
}

.customer-intake-field-group {
  display: grid;
  gap: 8px;
}

.customer-intake-choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.customer-intake-choice-card {
  min-height: 48px;
  margin: 0 !important;
  padding: 8px 12px;
  border: 1px solid rgba(16, 33, 56, 0.16);
  border-radius: 8px;
  transition:
    border-color 120ms ease,
    background-color 120ms ease;
}

.customer-intake-choice-card:hover {
  border-color: #4da7db;
  background: rgba(77, 167, 219, 0.04);
}

.customer-intake-choice-card.is-selected {
  border-color: #4da7db;
  background: rgba(77, 167, 219, 0.08);
}

.customer-intake-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 28px;
}

.customer-intake-success-card,
.customer-intake-state-card {
  max-width: 640px;
  margin: 48px auto;
  padding: 40px 28px;
  text-align: center;
}

.customer-intake-success-icon {
  color: #2e7d32;
  font-size: 56px !important;
}

.customer-intake-state-icon {
  color: #4da7db;
  font-size: 56px !important;
}

.customer-intake-public-footer {
  padding: 0 24px 24px;
  color: #6b7c8f;
  text-align: center;
}

:root.dark .customer-intake-public-page {
  background: #0e1621;
  color: #e6edf3;
}

:root.dark .parent-lookup-page {
  background-image:
    linear-gradient(
      115deg,
      rgba(14, 22, 33, 0.88),
      rgba(14, 22, 33, 0.82) 48%,
      rgba(14, 22, 33, 0.9)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

:root.dark .customer-intake-public-header {
  background: #16202c;
  border-bottom-color: rgba(230, 237, 243, 0.14);
}

:root.dark .parent-lookup-page .customer-intake-public-header {
  background: rgba(22, 32, 44, 0.82);
}

:root.dark .customer-intake-brand-name,
:root.dark .customer-intake-title {
  color: #e6edf3;
}

:root.dark .customer-intake-brand-tagline,
:root.dark .customer-intake-subtitle,
:root.dark .customer-intake-public-footer {
  color: #9fb2c4;
}

:root.dark .customer-intake-card {
  border-color: rgba(230, 237, 243, 0.14);
  background: #16202c;
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.24);
}

:root.dark .parent-lookup-page .parent-lookup-poster-card,
:root.dark .parent-lookup-page .parent-lookup-form-card {
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

:root.dark .parent-lookup-page .parent-lookup-student-card {
  border: 0;
  border-radius: 0;
  background: rgba(22, 32, 44, 0.62);
  box-shadow: none;
  backdrop-filter: blur(6px);
}

:root.dark .parent-lookup-package-card {
  background: rgba(28, 43, 58, 0.56);
  backdrop-filter: blur(5px);
}

:root.dark .parent-lookup-service-tabs {
  border-bottom-color: rgba(230, 237, 243, 0.14);
}

:root.dark .parent-lookup-class-card {
  background: rgba(22, 32, 44, 0.48);
  backdrop-filter: blur(5px);
}

:root.dark .parent-lookup-poster-frame {
  background: transparent;
}

:root.dark
  .parent-lookup-search-layout--without-poster
  .parent-lookup-form-card {
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

@media (max-width: 900px) {
  .parent-lookup-search-layout {
    grid-template-columns: 1fr;
  }

  .parent-lookup-poster-frame {
    min-height: 0;
  }
}

@media (max-width: 600px) {
  .customer-intake-public-header-inner {
    min-height: 64px;
  }

  .customer-intake-brand-tagline {
    display: none;
  }

  .customer-intake-page-container {
    padding-top: 28px;
    padding-bottom: 32px;
  }

  .customer-intake-qr-card,
  .customer-intake-info-card,
  .customer-intake-form-card,
  .customer-intake-policy-card,
  .parent-lookup-form-card,
  .parent-lookup-student-card,
  .parent-lookup-poster-card {
    padding: 20px;
  }

  .parent-lookup-package-meta {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .customer-intake-choice-grid {
    grid-template-columns: 1fr;
  }

  .customer-intake-form-actions {
    display: grid;
    grid-template-columns: 1fr;
  }
}

@media print {
  .customer-intake-public-header,
  .customer-intake-hero,
  .customer-intake-qr-actions,
  .customer-intake-public-footer,
  .customer-intake-qr-link,
  .customer-intake-qr-note {
    display: none !important;
  }

  .customer-intake-public-page,
  .customer-intake-page-container {
    min-height: auto;
    padding: 0;
    background: #ffffff;
  }

  .customer-intake-card {
    border: 0;
    box-shadow: none;
  }

  .customer-intake-qr-card {
    padding: 0;
  }

  .customer-intake-qr-frame canvas {
    width: 320px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomerIntake/customerIntake.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;;;;;;;2CAOqC;EACrC,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB;;+BAE6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;;;;;;;2CAOqC;EACrC,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;;;;;;;IAOE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;;;IAME,wBAAwB;EAC1B;;EAEA;;IAEE,gBAAgB;IAChB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".customer-intake-public-page {\n  min-height: 100vh;\n  background: #f7fbfd;\n  color: #102138;\n}\n\n.parent-lookup-page {\n  background-image:\n    linear-gradient(\n      115deg,\n      rgba(247, 251, 253, 0.86),\n      rgba(247, 251, 253, 0.78) 48%,\n      rgba(247, 251, 253, 0.88)\n    ),\n    url('../../assets/Signin/Pool.jpg');\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.parent-lookup-page .customer-intake-public-header {\n  background: rgba(255, 255, 255, 0.76);\n  backdrop-filter: blur(12px);\n}\n\n.customer-intake-public-header {\n  background: #ffffff;\n  border-bottom: 1px solid rgba(16, 33, 56, 0.1);\n}\n\n.customer-intake-public-header-inner {\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.customer-intake-public-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: #4da7db;\n}\n\n.customer-intake-public-header-actions .MuiIconButton-root {\n  padding: 6px;\n}\n\n.customer-intake-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.customer-intake-brand-mark {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: #ffffff;\n  background: #4da7db;\n}\n\n.customer-intake-brand-mark img {\n  display: block;\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n  border-radius: 5px;\n}\n\n.customer-intake-brand-name {\n  color: #102138;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.customer-intake-brand-tagline {\n  color: #6b7c8f;\n  font-size: 0.72rem;\n  font-style: italic;\n  line-height: 1.3;\n}\n\n.customer-intake-page-container {\n  padding-top: 40px;\n  padding-bottom: 48px;\n}\n\n.customer-intake-hero {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.customer-intake-eyebrow {\n  color: #4da7db;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.customer-intake-title {\n  color: #102138;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.customer-intake-subtitle {\n  display: block;\n  width: 100%;\n  margin: 10px auto 0;\n  text-align: center;\n  color: #607285;\n}\n\n.customer-intake-card {\n  border: 1px solid rgba(16, 33, 56, 0.1);\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 26px rgba(16, 33, 56, 0.07);\n}\n\n.customer-intake-qr-card {\n  padding: 28px;\n}\n\n.customer-intake-qr-frame {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  border: 1px solid rgba(77, 167, 219, 0.25);\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.customer-intake-qr-frame canvas {\n  display: block;\n  width: min(100%, 320px);\n  height: auto;\n}\n\n.customer-intake-qr-link {\n  overflow-wrap: anywhere;\n  color: #4d6e8a;\n}\n\n.customer-intake-qr-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n}\n\n.customer-intake-info-card {\n  height: 100%;\n  padding: 28px;\n}\n\n.customer-intake-info-list {\n  display: grid;\n  gap: 18px;\n  margin: 24px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.customer-intake-info-list li {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.customer-intake-info-list svg {\n  flex: 0 0 auto;\n  margin-top: 2px;\n  color: #4da7db;\n}\n\n.customer-intake-form-container {\n  max-width: 760px;\n}\n\n.customer-intake-form-card {\n  padding: 30px;\n}\n\n.parent-lookup-form-card {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 30px;\n}\n\n.parent-lookup-search-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.95fr);\n  gap: 24px;\n  max-width: 1080px;\n  margin: 0 auto;\n  align-items: stretch;\n}\n\n.parent-lookup-poster-card {\n  max-width: none;\n  margin: 0;\n  padding: 24px;\n}\n\n.parent-lookup-poster-frame {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  overflow: hidden;\n  background: transparent;\n}\n\n.parent-lookup-poster {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.parent-lookup-search-layout .parent-lookup-form-card {\n  max-width: none;\n  margin: 0;\n}\n\n.parent-lookup-form-column {\n  min-width: 0;\n}\n\n.parent-lookup-search-layout--without-poster {\n  display: block;\n  width: 100%;\n  max-width: 1080px;\n}\n\n.parent-lookup-search-layout--without-poster .parent-lookup-form-card {\n  width: 100%;\n  max-width: none;\n  margin: 0 auto;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.parent-lookup-search-layout:not(\n    .parent-lookup-search-layout--without-poster\n  )\n  .parent-lookup-poster-card,\n.parent-lookup-search-layout:not(\n    .parent-lookup-search-layout--without-poster\n  )\n  .parent-lookup-form-card {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  padding: 0;\n}\n\n.parent-lookup-results {\n  width: 100%;\n  max-width: 1080px;\n  margin-top: 24px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.parent-lookup-form-column .parent-lookup-results {\n  max-width: none;\n  margin: 24px 0 0;\n}\n\n.parent-lookup-no-match {\n  width: 100%;\n  margin-top: 16px;\n}\n\n.parent-lookup-captcha-widget {\n  min-height: 65px;\n  display: flex;\n  align-items: center;\n}\n\n.parent-lookup-student-card {\n  padding: 28px;\n  background: rgba(255, 255, 255, 0.62);\n  backdrop-filter: blur(6px);\n}\n\n.parent-lookup-service-tabs {\n  border-bottom: 1px solid rgba(16, 33, 56, 0.12);\n}\n\n.parent-lookup-package-card {\n  padding: 20px;\n  background: rgba(251, 253, 255, 0.56);\n  backdrop-filter: blur(5px);\n}\n\n.parent-lookup-package-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.parent-lookup-class-card {\n  padding: 14px;\n  background: rgba(255, 255, 255, 0.48);\n  backdrop-filter: blur(5px);\n}\n\n.customer-intake-policy-card {\n  padding: 32px;\n}\n\n.customer-intake-policy-section {\n  scroll-margin-top: 24px;\n}\n\n.customer-intake-policy-list .MuiListItemIcon {\n  min-width: 36px;\n}\n\n.customer-intake-form-section {\n  padding: 24px 0;\n  border-top: 1px solid rgba(16, 33, 56, 0.1);\n}\n\n.customer-intake-form-section:first-of-type {\n  padding-top: 0;\n  border-top: 0;\n}\n\n.customer-intake-field-group {\n  display: grid;\n  gap: 8px;\n}\n\n.customer-intake-choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.customer-intake-choice-card {\n  min-height: 48px;\n  margin: 0 !important;\n  padding: 8px 12px;\n  border: 1px solid rgba(16, 33, 56, 0.16);\n  border-radius: 8px;\n  transition:\n    border-color 120ms ease,\n    background-color 120ms ease;\n}\n\n.customer-intake-choice-card:hover {\n  border-color: #4da7db;\n  background: rgba(77, 167, 219, 0.04);\n}\n\n.customer-intake-choice-card.is-selected {\n  border-color: #4da7db;\n  background: rgba(77, 167, 219, 0.08);\n}\n\n.customer-intake-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 28px;\n}\n\n.customer-intake-success-card,\n.customer-intake-state-card {\n  max-width: 640px;\n  margin: 48px auto;\n  padding: 40px 28px;\n  text-align: center;\n}\n\n.customer-intake-success-icon {\n  color: #2e7d32;\n  font-size: 56px !important;\n}\n\n.customer-intake-state-icon {\n  color: #4da7db;\n  font-size: 56px !important;\n}\n\n.customer-intake-public-footer {\n  padding: 0 24px 24px;\n  color: #6b7c8f;\n  text-align: center;\n}\n\n:root.dark .customer-intake-public-page {\n  background: #0e1621;\n  color: #e6edf3;\n}\n\n:root.dark .parent-lookup-page {\n  background-image:\n    linear-gradient(\n      115deg,\n      rgba(14, 22, 33, 0.88),\n      rgba(14, 22, 33, 0.82) 48%,\n      rgba(14, 22, 33, 0.9)\n    ),\n    url('../../assets/Signin/Pool.jpg');\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n:root.dark .customer-intake-public-header {\n  background: #16202c;\n  border-bottom-color: rgba(230, 237, 243, 0.14);\n}\n\n:root.dark .parent-lookup-page .customer-intake-public-header {\n  background: rgba(22, 32, 44, 0.82);\n}\n\n:root.dark .customer-intake-brand-name,\n:root.dark .customer-intake-title {\n  color: #e6edf3;\n}\n\n:root.dark .customer-intake-brand-tagline,\n:root.dark .customer-intake-subtitle,\n:root.dark .customer-intake-public-footer {\n  color: #9fb2c4;\n}\n\n:root.dark .customer-intake-card {\n  border-color: rgba(230, 237, 243, 0.14);\n  background: #16202c;\n  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.24);\n}\n\n:root.dark .parent-lookup-page .parent-lookup-poster-card,\n:root.dark .parent-lookup-page .parent-lookup-form-card {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n:root.dark .parent-lookup-page .parent-lookup-student-card {\n  border: 0;\n  border-radius: 0;\n  background: rgba(22, 32, 44, 0.62);\n  box-shadow: none;\n  backdrop-filter: blur(6px);\n}\n\n:root.dark .parent-lookup-package-card {\n  background: rgba(28, 43, 58, 0.56);\n  backdrop-filter: blur(5px);\n}\n\n:root.dark .parent-lookup-service-tabs {\n  border-bottom-color: rgba(230, 237, 243, 0.14);\n}\n\n:root.dark .parent-lookup-class-card {\n  background: rgba(22, 32, 44, 0.48);\n  backdrop-filter: blur(5px);\n}\n\n:root.dark .parent-lookup-poster-frame {\n  background: transparent;\n}\n\n:root.dark\n  .parent-lookup-search-layout--without-poster\n  .parent-lookup-form-card {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n@media (max-width: 900px) {\n  .parent-lookup-search-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .parent-lookup-poster-frame {\n    min-height: 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .customer-intake-public-header-inner {\n    min-height: 64px;\n  }\n\n  .customer-intake-brand-tagline {\n    display: none;\n  }\n\n  .customer-intake-page-container {\n    padding-top: 28px;\n    padding-bottom: 32px;\n  }\n\n  .customer-intake-qr-card,\n  .customer-intake-info-card,\n  .customer-intake-form-card,\n  .customer-intake-policy-card,\n  .parent-lookup-form-card,\n  .parent-lookup-student-card,\n  .parent-lookup-poster-card {\n    padding: 20px;\n  }\n\n  .parent-lookup-package-meta {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .customer-intake-choice-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .customer-intake-form-actions {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n}\n\n@media print {\n  .customer-intake-public-header,\n  .customer-intake-hero,\n  .customer-intake-qr-actions,\n  .customer-intake-public-footer,\n  .customer-intake-qr-link,\n  .customer-intake-qr-note {\n    display: none !important;\n  }\n\n  .customer-intake-public-page,\n  .customer-intake-page-container {\n    min-height: auto;\n    padding: 0;\n    background: #ffffff;\n  }\n\n  .customer-intake-card {\n    border: 0;\n    box-shadow: none;\n  }\n\n  .customer-intake-qr-card {\n    padding: 0;\n  }\n\n  .customer-intake-qr-frame canvas {\n    width: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
